import RemoteCall from "../../../util/RemoteCall";

const remoteCall = new RemoteCall("api/renyuan/rpc/config");

/**
 * 列出医院开通应用
 * @param param = {hospitalId}
 * @returns {Promise | Promise<unknown>}
 */
function listCorpAppAsync(param) {
    return remoteCall.invoke("listCorpApp", param);
}

/**
 * 列出医院开通应用服务，目前只有同步排班考勤统计
 * @param param = {hospitalId, consumer}
 * @returns {Promise | Promise<unknown>}
 */
function listRegistryServiceAsync(param) {
    return remoteCall.invoke("listRegistryService", param);
}

export default {
    listCorpAppAsync,
    listRegistryServiceAsync,
}
